import React, { PropsWithChildren, useEffect, useState } from "react";
import { Platform } from "react-native";
import * as Updates from "expo-updates";
import { errorReporting } from "../helpers/errorReporting";
import { LoadingScreen } from "../screens/LoadingScreen";
import { useTranslation } from "react-i18next";
import { config } from "../config";

const skipUpdate = Platform.OS === "web" || config.isDevelopment;

export const UpdatesProvider = (props: PropsWithChildren) => {
  const { t } = useTranslation("UpdatesProvider");
  const [initalized, setInitalized] = useState(false);
  const [status, setStatus] = useState<"checking" | "downloading" | "ready">(
    skipUpdate ? "ready" : "checking",
  );

  useEffect(() => {
    if (skipUpdate) return;

    const performUpdate = async () => {
      try {
        const update = await Updates.checkForUpdateAsync();
        if (update.isAvailable) {
          setStatus("downloading");
          await Updates.fetchUpdateAsync();
          await Updates.reloadAsync();
        }
      } catch {
        errorReporting.sendMessage("Check for update failed (silently)");
      }

      setStatus("ready");
    };

    // check for updates on first load
    if (!initalized) {
      performUpdate();
      setInitalized(true);
    } else {
      setStatus("ready");
    }
  }, [initalized]);

  if (status !== "ready") {
    return (
      <LoadingScreen
        message={t(
          status === "checking" ? "Checking for update" : "Downloading update",
        )}
      />
    );
  }

  return props.children;
};
